import { Injectable } from "@angular/core";
import { DefaultDataServiceConfig, Logger } from "@ngrx/data";
import { HttpClient } from "@angular/common/http";
import { AbstractDataServiceV2 } from "src/app/modules/core/service/v2/dataservice/abstractDataServiceV2";
import { CustomizeHttpUrlGenerator } from "src/app/store/core/url/customizeHttpUrlGenerator";
import { MedicalDeviceModel } from "../../../api/entity/medicalDevice.model";
import { MedicalDeviceConverter } from "../../../api/entity/converter/medicalDevice.converter";

@Injectable({
    providedIn: 'root'
})
export class MedicalDeviceDataService extends AbstractDataServiceV2<MedicalDeviceModel, MedicalDeviceConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: MedicalDeviceConverter
    ) {
        super('MedicalDevice', http, httpUrlGenerator, logger, config, converter);
    }
}

